export default __webpack_public_path__ + "static/media/login.2bf76635.png";